{
  "app": {
    "newUpdateAvailable": "New update available",
    "newUpdateAvailableDescription": "Please reload the app to get the latest version",
    "reloadApp": "Reload app",
    "cancel": "Cancel",
    "error": {
      "title": "Something went wrong",
      "message": "An unexpected error occurred. Please try again.",
      "takeMeHome": "Take me home"
    },
    "sessionExpired": {
      "title": "Session expired",
      "message": "Your session has expired. Please sign in again.",
      "ok": "OK"
    }
  },
  "ExpoUpdateBottomSheet": {
    "title": "A new update is available",
    "description": "Update now to get the latest features, improvements, and bug fixes.",
    "apply": "Update",
    "cancel": "Cancel"
  },
  "BetaEndedModal": {
    "title": "The beta has ended",
    "body": "Thanks so much for being part of the Squire beta! We hope you enjoyed getting an early look.",
    "reassurance": "Don't worry — you won't lose any of your data.",
    "downloadButtonIos": "Download from the App Store",
    "downloadButtonAndroid": "Download from Google Play",
    "accessibility": {
      "downloadButtonHint": "Opens the app's store listing"
    }
  },
  "DevMenu": {
    "title": "Developer Settings",
    "buttonLabel": "😛",
    "clearStorage": "Clear Storage",
    "testErrorBoundary": "Test Error Boundary",
    "triggerNPSSurvey": "Trigger NPS Survey",
    "triggerAppStoreReview": "Trigger App Store Review",
    "triggerRatingPrompt": "Trigger Rating Prompt",
    "environment": "Environment",
    "bnplVariant": "BNPL checkout variant",
    "bnplVariantFromLaunchDarkly": "Use LaunchDarkly",
    "bnplVariantControl": "Control",
    "bnplVariantPayLater": "Pay later",
    "bnplVariantNowLater": "Pay now / Pay later",
    "depositMock": "Mock booking deposit",
    "depositMockOff": "Off",
    "depositMockRefundable": "Refundable",
    "depositMockNonRefundable": "Non-refundable",
    "appId": "App ID",
    "appVersion": "App Version",
    "runtimeVersion": "Runtime Version",
    "appearance": "Appearance",
    "light": "Light",
    "dark": "Dark",
    "language": "Language",
    "actions": "Actions",
    "toasts": "Toasts",
    "toastSuccess": "Success toast",
    "toastError": "Error toast",
    "toastInfo": "Info toast",
    "toastLong": "Long toast",
    "toastSuccessMessage": "Your appointment is booked",
    "toastErrorMessage": "We couldn't process your payment",
    "toastInfoMessage": "Your barber is running a few minutes late",
    "toastLongMessage": "We couldn't book this time because another client just took it. Please pick a different time.",
    "toastLongDescription": "Your card was not charged."
  },
  "shared": {
    "locationPermission": {
      "denied": "Permission to access location was denied",
      "openSettings": "Open Settings"
    },
    "photoPermission": {
      "cameraDenied": "Permission to access camera was denied",
      "libraryDenied": "Permission to access photo library was denied",
      "openSettings": "Open Settings"
    },
    "openDirections": {
      "title": "Open in Maps",
      "description": "Choose your preferred map app",
      "cancel": "Cancel"
    },
    "resendOtpButton": {
      "resendCode": "Resend the code",
      "resendIn": "Resend in {{seconds}}s",
      "didNotReceiveCode": "Didn't receive anything? Try again.",
      "accessibility": {
        "resendSection": "Code resend options",
        "resendButton": "Resend verification code",
        "resendButtonHint": "Request a new verification code to be sent to your phone"
      }
    },
    "otpInput": {
      "accessibility": {
        "label": "Verification code input",
        "hint": "Enter the verification code"
      }
    },
    "screenHeader": {
      "backButton": {
        "accessibilityLabel": "Go back",
        "accessibilityHint": "Return to previous screen"
      },
      "closeButton": {
        "accessibilityLabel": "Close",
        "accessibilityHint": "Close and return to previous screen"
      },
      "widgetCloseButton": {
        "accessibilityLabel": "Close widget",
        "accessibilityHint": "Close the booking widget"
      },
      "languageButton": {
        "accessibilityLabel": "Change language",
        "accessibilityHint": "Opens the language picker"
      }
    },
    "validation": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address"
    }
  },
  "HomeDrawer": {
    "greeting": "Hey, {{name}}",
    "viewProfile": "View profile",
    "appointments": "Appointments",
    "standby": "Waitlist",
    "cards": "Cards",
    "terms": "Terms",
    "privacy": "Privacy",
    "support": "Support",
    "language": "Language",
    "signOut": "Sign out",
    "accessibility": {
      "closeDrawer": "Close menu drawer",
      "profileSection": "User profile section",
      "profileButton": "View profile",
      "profileButtonHint": "Navigate to your profile page",
      "menuSection": "Main menu options",
      "appointmentsButton": "View appointments",
      "appointmentsButtonHint": "Navigate to your appointments",
      "standbyButton": "Waitlist, {{count}} active",
      "standbyButtonHint": "Navigate to your waitlist",
      "cardsButton": "Manage cards",
      "cardsButtonHint": "Navigate to your saved cards",
      "termsButton": "View terms and conditions",
      "termsButtonHint": "Open terms of service",
      "privacyButton": "View privacy policy",
      "privacyButtonHint": "Open privacy policy",
      "supportButton": "Get help and support",
      "supportButtonHint": "Contact customer support",
      "languageButton": "Language",
      "languageButtonHint": "Change app language",
      "signOutButton": "Sign out of your account",
      "signOutButtonHint": "Logout from the application",
      "closeDrawerHint": "Closes the menu drawer"
    }
  },
  "CardsScreen": {
    "title": "Cards",
    "emptyTitle": "You don't have any saved cards",
    "invalidCard": "Card is no longer valid",
    "applePay": "Apple Pay",
    "expires": "Expires {{date}}",
    "error": "Unable to load cards",
    "tryAgain": "Try again",
    "setDefaultSuccess": "Default payment method updated",
    "setDefaultErrorTitle": "Couldn't update your default card",
    "setDefaultErrorDescription": "Please try again.",
    "removeCard": "Remove",
    "removeCardError": "Couldn't remove card. Please try again.",
    "removeCardErrorMarkedDefault": "Set another card as your default before removing this one.",
    "removeCardErrorAttachedToAppointment": "This card can't be removed because it's attached to an upcoming appointment.",
    "removeCardErrorUnfinishedSale": "This card is being used for a payment that's still processing. You can remove it once that completes.",
    "addCard": "Add a new card",
    "addCardTitle": "Add a new card",
    "cardLabel": "Card",
    "makeDefault": "Make default",
    "addCardConfirm": "Add card",
    "addCardError": "Your card couldn't be added. Check the details or try a different card.",
    "addCardSuccess": "Card was added successfully",
    "cardLimitNotice": "You can save up to {{limit}} cards, swipe a card left to remove one.",
    "accessibility": {
      "card": "Card ending in {{last4}}",
      "removeCard": "Remove card ending in {{last4}}"
    }
  },
  "RouteAnnouncer": {
    "chooseLocation": "Choose a location",
    "chooseProfessional": "Choose a professional",
    "chooseService": "Choose a service",
    "chooseTime": "Choose a time",
    "buyGiftCard": "Buy a gift card"
  },
  "WaitingRoom": {
    "title": "SQUIRE is currently unavailable.",
    "message": "Once it becomes available, we'll let you in automatically...",
    "contactSupport": "Contact support",
    "closeButton": {
      "accessibilityLabel": "Close widget",
      "accessibilityHint": "Close the booking widget"
    }
  },
  "LanguageBottomSheet": {
    "title": "Language",
    "english": "English",
    "spanish": "Español",
    "french": "Français",
    "englishShort": "EN",
    "spanishShort": "ES",
    "frenchShort": "FR",
    "currentLanguage": "Current language: {{language}}",
    "confirmButton": "Confirm Language",
    "languageUpdateError": "We couldn't update your language. Please try again.",
    "languageNames": {
      "english": "English",
      "spanish": "Spanish",
      "french": "French"
    },
    "accessibility": {
      "closeButton": "Close language selection",
      "closeButtonHint": "Closes the language selection",
      "selectLanguageHint": "Select {{language}} as app language",
      "confirmButton": "Confirm language selection",
      "confirmButtonHint": "Apply the selected language to the app",
      "radioButton": "{{language}} radio button",
      "radioButtonSelected": "{{language}} is currently selected"
    }
  },
  "AuthScreen": {
    "errorTitle": "Error",
    "title": "Create an account\nor Log in",
    "continueWithApple": "Continue with Apple",
    "continueWithAppleLabel": "Continue with Apple",
    "or": "OR",
    "ok": "Ok",
    "signUp": "Sign up",
    "signIn": "Sign in",
    "close": "Close",
    "dataUsageInfo": "By continuing, you agree to our Terms of Service and Privacy Policy",
    "appleSignInError": "Apple Sign-in failed. Please try again.",
    "accessibility": {
      "closeButton": "Close authentication screen",
      "closeButtonHint": "Returns to the previous screen",
      "authIcon": "Authentication icon",
      "appleSignInButton": "Continue with Apple",
      "appleSignInButtonHint": "Sign in using your Apple ID",
      "googleSignInButton": "Continue with Google",
      "googleSignInButtonHint": "Sign in using your Google account",
      "signUpButton": "Create a new account",
      "signUpButtonHint": "Navigate to sign up flow",
      "signInButton": "Sign in with email",
      "signInButtonHint": "Navigate to email sign in flow",
      "separator": "OR separator",
      "screen": "Authentication screen",
      "methods": "Authentication methods",
      "loading": "Signing in"
    },
    "continueWithGoogle": "Continue with Google",
    "continueWithGoogleLabel": "Continue with Google",
    "signingInWithGoogle": "Signing in with Google..."
  },
  "LoginScreen": {
    "title": "Welcome back!",
    "signInToContinue": "Sign in to continue",
    "email": "Email",
    "enterYourEmail": "Enter your email",
    "password": "Password",
    "enterYourPassword": "Enter your password",
    "signIn": "Sign In"
  },
  "HomeScreen": {
    "welcome": "Welcome to Squire,\nfind a barbershop near you.",
    "signIn": "Sign up / Log in",
    "logIn": "Log in",
    "giveFeedback": "Give feedback",
    "nearby": "NEARBY",
    "search": "SEARCH",
    "book": "Book",
    "haveAppointment": "I have an appointment",
    "openSupportEmailError": "Error opening support email",
    "noEmailAppError": "No email app found on this device. Please install a mail app to contact support.",
    "seeMore": "Want to see more?\nBrowse shops",
    "location": "Location",
    "locationDescription": "We'll need your location to find barbershops near you",
    "continue": "Continue",
    "title": "Choose a location",
    "searchPlaceholder": "Search for barbershops, barbers, or brands",
    "locationSearchPlaceholder": "Enter location",
    "locationSearchNotice": "The map view isn’t available in this version. You can still browse nearby locations below.",
    "getDirections": "Get directions",
    "noResults": "No results found",
    "noResultsDescription": "Try adjusting your search terms or check your spelling",
    "startSearching": "Start typing to search",
    "startSearchingDescription": "Search for barbershops, barbers,\nor brands in your area",
    "noOtherLocations": "No other locations",
    "noOtherLocationsDescription": "This brand has no other locations you can\nmove this booking to",
    "location_one": "{{count}} Location",
    "location_other": "{{count}} Locations",
    "searchResults": "SEARCH RESULTS",
    "noResultsFound": "No results found. Try\ndifferent search term.",
    "accessibility": {
      "menuButton": "Open menu",
      "menuButtonHint": "Opens the main navigation menu",
      "signInButton": "Log in",
      "signInButtonHint": "Log in to your account",
      "giveFeedbackButton": "Give feedback",
      "giveFeedbackButtonHint": "Opens an email to share feedback about the beta app",
      "welcomeMessage": "Welcome message",
      "nearbyButton": "{{count}} nearby barbershops",
      "nearbyButtonActive": "Disable nearby search",
      "nearbyButtonInactive": "Find barbershops near your location",
      "searchButton": "{{count}} barbershops",
      "searchButtonHint": "Search for barbershops, barbers, or brands",
      "dismissLocationSearchNotice": "Dismiss notice",
      "searchResultButton": "Search result: {{searchTerm}}",
      "searchResultButtonHint": "Clear search and return to all barbershops",
      "clearSearchButton": "Clear search",
      "clearSearchButtonHint": "Remove current search filter",
      "appointmentButton": "I have an appointment",
      "appointmentButtonHint": "View your existing appointments",
      "barbershopCard": "{{name}}, located at {{address}}, approximately {{distance}} away",
      "barbershopCardHint": "Book an appointment at this barbershop",
      "barbershopPhoto": "Photo of {{name}}",
      "bookButton": "Book appointment at {{name}}",
      "bookButtonHint": "Schedule an appointment at this barbershop",
      "carouselList": "{{count}} barbershops",
      "carouselListHint": "Swipe horizontally to browse barbershops",
      "seeMoreButton": "See more barbershops",
      "seeMoreButtonHint": "Browse more barbershops"
    },
    "betaFeedbackEmail": {
      "subject": "Squire iOS Beta Feedback — {{appVersion}} (Build {{buildNumber}})",
      "descriptionPrompt": "What's this about?",
      "descriptionPlaceholder": "[Tap here to describe what happened]",
      "reproStepsLabel": "Steps to reproduce (if applicable):",
      "expectedLabel": "What did you expect to happen?",
      "actualLabel": "What actually happened?",
      "screenshotPrompt": "Please attach a screenshot if you can — it helps a lot!",
      "diagnosticsLabel": "Auto-included:",
      "deviceLabel": "Device",
      "appVersionLabel": "App Version",
      "buildNumberLabel": "Build Number",
      "userIdLabel": "User ID",
      "timestampLabel": "Timestamp"
    }
  },
  "PasswordRequirements": {
    "length": "At least 8 characters long",
    "letter": "Must contain a letter",
    "specialChar": "One number or special character"
  },
  "SignUpAvatarScreen": {
    "title": "One more thing",
    "subtitle": "Set up your profile picture\nif you wish.",
    "avatarPlaceholder": "[Avatar selection UI will be implemented here]",
    "selectAvatar": "Select Photo",
    "skip": "I'll do it later",
    "uploadError": {
      "title": "Upload Failed",
      "message": "Failed to upload your profile photo. Please try again.",
      "noCustomerId": "Unable to upload photo at this time. Please try again later."
    },
    "galleryError": {
      "title": "Gallery Error",
      "message": "Failed to select photo. Please try again."
    },
    "accessibility": {
      "selectAvatarButton": "Select profile photo",
      "selectAvatarButtonHint": "Choose a photo for your profile",
      "skipButton": "Skip adding photo",
      "skipButtonHint": "Continue without adding a profile photo",
      "screen": "Avatar selection screen"
    }
  },
  "SignUpEmailScreen": {
    "title": "Create an account",
    "email": "EMAIL",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Enter your email",
    "password": "PASSWORD",
    "passwordLabel": "PASSWORD",
    "passwordPlaceholder": "Enter your password",
    "continue": "Continue",
    "accessibility": {
      "closeButton": "Close signup flow",
      "closeButtonHint": "Returns to the previous screen",
      "emailInput": "Email address",
      "passwordInput": "Password",
      "showPasswordButton": "Show password",
      "hidePasswordButton": "Hide password",
      "continueButton": "Continue to next step",
      "continueButtonHint": "Proceed to enter personal details"
    }
  },
  "SignUpSecondStepScreen": {
    "title": "Second step",
    "subtitle": "Tell us a few more\ndetails about you...",
    "firstNameLabel": "FIRST NAME",
    "firstNamePlaceholder": "First name",
    "lastNameLabel": "LAST NAME",
    "lastNamePlaceholder": "Last name",
    "phoneLabel": "PHONE",
    "phonePlaceholder": "+1 (555) 123-4567",
    "phoneDescription": "We'll send you a verification code via SMS",
    "continue": "Continue",
    "close": "Close",
    "creatingAccount": "Creating account...",
    "errorTitle": "Error",
    "validation": {
      "firstNameRequired": "First name is required",
      "firstNameInvalid": "First name can't contain numbers",
      "lastNameRequired": "Last name is required",
      "lastNameInvalid": "Last name can't contain numbers",
      "phoneInvalid": "Please enter a valid phone number"
    },
    "errors": {
      "emailExists": "An account with this email already exists. Please sign in instead.",
      "invalidPhone": "Please enter a valid phone number",
      "general": "Something went wrong. Please try again."
    },
    "accessibility": {
      "backButton": "Go back",
      "backButtonHint": "Returns to the previous step",
      "closeButton": "Close signup flow",
      "closeButtonHint": "Cancels the signup process",
      "firstNameInput": "First name",
      "lastNameInput": "Last name",
      "phoneInput": "Phone number with country code",
      "phoneInputHint": "Include country code, e.g., +1 for US",
      "continueButton": "Create account and continue",
      "continueButtonHint": "Creates your account and sends verification code"
    }
  },
  "SignUpOtpScreen": {
    "title": "Verify please",
    "subtitle": "We have sent a 6-digit verification\ncode to phone ending {{phone}}",
    "otpLabel": "6-DIGIT CODE",
    "otpCode": "Code",
    "resendCode": "Resend the code",
    "didNotReceiveCode": "Didn't receive anything? Try again.",
    "codeSent": "Code sent",
    "validCode": "Code verified",
    "invalidCode": "Invalid code",
    "accessibility": {
      "backButton": "Go back",
      "backButtonHint": "Returns to the previous step",
      "closeButton": "Close signup flow",
      "closeButtonHint": "Cancels the signup process",
      "otpInput": "6-digit verification code",
      "otpInputHint": "Enter the 6-digit verification code sent to your phone",
      "verifyButton": "Verify code and continue",
      "verifyButtonHint": "Verifies your phone number and proceeds to next step",
      "resendButton": "Resend verification code",
      "resendButtonHint": "Request a new verification code to be sent to your phone",
      "resendSection": "Code resend options",
      "phoneNumber": "Code sent to {{phone}}",
      "otpForm": "Verification code input form"
    }
  },
  "SignUpConfirmationScreen": {
    "title": "All set!",
    "subtitle": "You're good to go to view your\nhome screen.",
    "continue": "Get started",
    "accessibility": {
      "successIcon": "Account creation successful",
      "continueButton": "Continue to app",
      "continueButtonHint": "Navigate to the main app",
      "screen": "Signup confirmation screen"
    }
  },
  "SignInEmailScreen": {
    "title": "Sign in",
    "subtitle": "Sign in to your account\nwith your email address",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Enter your email",
    "submitButton": "Submit",
    "emailNotFound": "This account doesn't exist. Create an acount instead or use a different email.",
    "accessibility": {
      "emailInput": "Email address input field",
      "emailInputHint": "Enter the email address associated with your account",
      "submitButton": "Submit email for verification",
      "submitButtonHint": "Send verification code to registered phone number",
      "screen": "Sign in with email screen"
    }
  },
  "SignInOtpScreen": {
    "title": "Sign in",
    "subtitle": "We have sent a 6-digit verification code to phone ending {{phone}}",
    "subtitleEmail": "We have sent a 6-digit verification code to your email inbox",
    "otpCode": "Code",
    "otpLabel": "6-DIGIT CODE",
    "codeSent": "Code sent",
    "resendCode": "Resend the code",
    "didNotReceiveCode": "Didn't receive anything? Try again.",
    "validCode": "Code verified",
    "networkError": "Something went wrong. Please try again.",
    "invalidCode": "Invalid code",
    "accessibility": {
      "phoneNumber": "Code sent to phone ending {{phone}}",
      "emailAddress": "Code sent to your email inbox",
      "otpForm": "Verification code form",
      "otpInput": "6-digit verification code input",
      "otpInputHint": "Enter the 6-digit verification code sent to your phone",
      "resendButton": "Resend verification code",
      "resendButtonHint": "Request a new verification code to be sent to your phone",
      "resendSection": "Code resend options",
      "screen": "Sign in verification screen"
    }
  },
  "AccountDisabledScreen": {
    "title": "Account is disabled",
    "subtitle": "If you want to sign in to your account submit a request to restore it",
    "disabledOn": "Disabled on {{date}}",
    "restoreAction": "Restore account",
    "cancelAction": "Cancel",
    "restoreEmail": {
      "subject": "Restore Account",
      "bodyPrefix": "Please restore my account with the following details:\nUser id: {{userId}}"
    },
    "accessibility": {
      "screen": "Account disabled screen",
      "avatar": "User avatar",
      "restoreButton": "Restore account",
      "restoreButtonHint": "Opens support email to request account restoration",
      "cancelButton": "Cancel",
      "cancelButtonHint": "Go back to sign in"
    }
  },
  "LookUpScreen": {
    "title": "Look up",
    "subtitle": "Enter your 6-digit appointment confirmation code.",
    "invalidCode": "The confirmation code or id provided is invalid.",
    "networkError": "Network error. Please try again.",
    "loading": "Looking up appointment...",
    "otpLabel": "6-DIGIT CODE",
    "accessibility": {
      "otpInput": "Appointment confirmation code input",
      "otpInputHint": "Enter your 6-digit appointment confirmation code",
      "lookupForm": "Appointment lookup form",
      "closeButton": "Close appointment lookup screen",
      "closeButtonHint": "Return to previous screen"
    }
  },
  "AppointmentHomeScreen": {
    "signIn": "Sign in",
    "viewMore": "View More",
    "bookAgain": "Book Again",
    "bookNew": "Book a new appointment",
    "withBarber": "with {{barberName}}",
    "upcomingAppointment": "UPCOMING",
    "lastAppointment": "YOUR LAST APPOINTMENT",
    "welcomeMessage": "Hey {{name}}, it's time to book your next appointment.",
    "analyzingBookings": "We're actively\nanalyzing your\nbookings…",
    "notifyToBook": "We'll notify\nyou when it's time\nto book again",
    "noAppointmentData": "No appointment data available",
    "noAppointmentDataSubtitle": "Please try looking up your appointment again.",
    "moreUpcomingAppointments_one": "{{count}} MORE UPCOMING APPOINTMENT",
    "moreUpcomingAppointments_other": "{{count}} MORE UPCOMING APPOINTMENTS",
    "accessibility": {
      "appointmentHomeScreen": "Appointment home screen",
      "signInButton": "Sign in to your account",
      "signInButtonHint": "Access your full account features",
      "viewMoreButton": "View more appointment details",
      "viewMoreButtonHint": "See additional information about this appointment",
      "bookAgainButton": "Book again at this shop",
      "bookAgainButtonHint": "Schedule another appointment at the same shop",
      "bookingAgain": "Booking again",
      "bookNewButton": "Book a new appointment",
      "bookNewButtonHint": "Schedule a new appointment",
      "appointmentCard": "Appointment details card",
      "appointmentCardHint": "Shows your appointment information"
    }
  },
  "AppointmentSignInScreen": {
    "title": "Sign in",
    "subtitle": "Sign in to your account with your phone number or email.",
    "subtitlePhoneOnly": "Sign in to your account with your phone number.",
    "subtitleEmailOnly": "Sign in to your account with your email.",
    "continueWith": "Continue with {{contact}} →",
    "verificationMessage": "We'll send you a verification code.",
    "supportMessage": "Don't recognize phone number or email. Please contact your barbershop or support@getsquire.com.",
    "useDifferentAccount": "Use a different account",
    "close": "Close",
    "noContactMethods": "No contact methods available",
    "accessibility": {
      "appointmentSignInScreen": "Appointment sign in screen",
      "closeButton": "Close sign in screen",
      "closeButtonHint": "Return to appointment details",
      "phoneSignInButton": "Sign in with phone number {{phone}}",
      "phoneSignInButtonHint": "Sign in using your registered phone number",
      "emailSignInButton": "Sign in with email {{email}}",
      "emailSignInButtonHint": "Sign in using your registered email address",
      "supportText": "Contact support information",
      "useDifferentAccountButton": "Use a different account"
    }
  },
  "AppointmentLookupCompleteProfileBottomSheet": {
    "title": "Required\ninformation",
    "subtitle": "For your security, please complete your profile below",
    "firstNameLabel": "FIRST NAME",
    "lastNameLabel": "LAST NAME",
    "phoneLabel": "PHONE",
    "emailLabel": "EMAIL",
    "firstNamePlaceholder": "First name",
    "lastNamePlaceholder": "Last name",
    "emailPlaceholder": "Email",
    "confirmButton": "Confirm",
    "footerText": "The email and phone number you provide will be used for appointment notifications.",
    "accessibility": {
      "closeButton": "Close complete profile form",
      "firstNameInput": "First name input field",
      "lastNameInput": "Last name input field",
      "phoneInput": "Phone number input field",
      "emailInput": "Email address input field",
      "confirmButton": "Confirm and submit profile information",
      "closeButtonHint": "Closes this form"
    },
    "validation": {
      "firstNameRequired": "First name is required",
      "firstNameInvalid": "First name can't contain numbers",
      "lastNameRequired": "Last name is required",
      "lastNameInvalid": "Last name can't contain numbers",
      "phoneRequired": "Phone number is required",
      "emailRequired": "Email address is required",
      "phoneInvalid": "Please enter a valid phone number",
      "emailInvalid": "Please enter a valid email address"
    }
  },
  "AppointmentsScreen": {
    "title": "Appointments",
    "upcoming": "UPCOMING",
    "past": "PAST",
    "at": "at",
    "barberAtShop": "{{firstName}} {{lastInitial}}. at {{shopName}}",
    "cancelled": "Cancelled",
    "noAppointments": "There are no appointments yet",
    "error": "Failed to load appointments. Please try again.",
    "tryAgain": "Try Again",
    "groupAppointmentCount": "{{count}} appointments at {{shop}}",
    "groupInitials": "M",
    "accessibility": {
      "appointmentItem": "Appointment on {{date}} with {{barber}} at {{shop}}",
      "groupAppointmentItem": "{{count}} appointments at {{shop}}"
    },
    "barberDetailsFormat": "{{firstName}} {{lastNameInitial}}. at {{shopName}}"
  },
  "AppointmentItem": {
    "cancelled": "Cancelled",
    "accessibility": {
      "appointmentItem": "Appointment item",
      "groupAppointmentItem": "Group appointment item"
    }
  },
  "availability": {
    "available": "Available\n{{date}}",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "anyProfessional": "Book with any\nprofessional"
  },
  "ChooseProfessionalScreen": {
    "title": "Choose a professional",
    "accessibility": {
      "closeButton": "Close",
      "closeButtonHint": "Return to previous screen"
    }
  },
  "ProfessionalGrid": {
    "anyProfessional": "Choose a service first",
    "availableToday": "Available Today",
    "error": {
      "title": "Something went wrong",
      "message": "We couldn't load the available professionals. Please try again later.",
      "goHome": "Go home"
    },
    "empty": {
      "title": "No Professionals Available",
      "message": "There are currently no available barbers at this location"
    }
  },
  "GiftCard": {
    "title": "Buy a gift card instead",
    "subtitle": "Give the gift of grooming"
  },
  "GiftCardAmountScreen": {
    "title": "Buy a gift card",
    "pleaseSelectAmount": "Please select amount",
    "previewTitle": "Gift Card",
    "previewSubtitle": "Give the gift of grooming",
    "previewAccessibilityLabelUnselected": "{{title}}. {{subtitle}}",
    "previewAccessibilityLabelSelected": "{{title}}. {{amount}}",
    "custom": "Custom",
    "viewOrder": "View Order",
    "summary": {
      "label": "Selected amount",
      "placeholder": "No amount selected"
    },
    "customAmount": {
      "placeholder": "Enter amount"
    },
    "processing": "Processing",
    "tryAgain": "Try Again"
  },
  "GiftCardOrderBar": {
    "viewOrder": "View Order",
    "continueButton": "Continue",
    "accessibility": {
      "expandHint": "Opens order summary",
      "orderSummary": "Gift card {{amount}}. Tap to view order."
    }
  },
  "GiftCardOrderBottomSheet": {
    "title": "Your Order",
    "giftCardItem": "Gift Card",
    "subtotal": "Subtotal",
    "continueButton": "Continue",
    "anyProfessional": "Any Professional",
    "accessibility": {
      "closeBottomSheet": "Close order summary",
      "closeBottomSheetHint": "Closes the order summary"
    }
  },
  "ConfirmGiftCardBottomSheet": {
    "title": "Buy gift card",
    "haveAccount": "Have an account?",
    "signIn": "Sign in",
    "buyGiftCard": "Buy gift card",
    "buyingGiftCard": "Buying gift card",
    "paymentMethod": "Payment Method",
    "creditOrDebitCard": "Card or bank account",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "giftCardSummary": "Gift Card",
    "legalText": "By continuing, you agree to our",
    "termsOfService": "Terms of Service",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "accessibility": {
      "bookButton": "Buy gift card",
      "bookButtonHint": "Completes your gift card purchase",
      "paymentMethod": "Payment method: {{method}}",
      "paymentMethodHint": "Select {{method}} as payment"
    },
    "userInformation": {
      "title": "Your Information",
      "firstNamePlaceholder": "First name",
      "lastNamePlaceholder": "Last name",
      "phonePlaceholder": "Phone number",
      "emailPlaceholder": "Email",
      "accessibility": {
        "firstNameInput": "First name",
        "lastNameInput": "Last name",
        "phoneInput": "Phone number",
        "phoneInputHint": "Enter your phone number",
        "emailInput": "Email address"
      },
      "validation": {
        "firstNameRequired": "First name is required",
        "firstNameInvalid": "First name must contain only letters",
        "lastNameRequired": "Last name is required",
        "lastNameInvalid": "Last name must contain only letters",
        "phoneInvalid": "Please enter a valid phone number",
        "emailInvalid": "Please enter a valid email address",
        "emailRequired": "Email is required",
        "paymentMethodRequired": "Please select a payment method"
      }
    },
    "error": {
      "purchaseFailed": "Something went wrong. Please try again.",
      "paymentError": "Payment failed. Please try again."
    }
  },
  "ViewGiftCardScreen": {
    "title": "Gift Card",
    "thankYouTitle": "Thank you for purchasing your gift card",
    "promotionalHeadline": "Give the gift of grooming",
    "promotionalDescription": "Everyone can appreciate looking good, so give yourself the gift of grooming!",
    "giftCardForShop": "This gift card is for {{shopName}}",
    "code": "Gift Card Code",
    "totalPrice": "Total Price",
    "anyProfessional": "Any Professional",
    "giftCardItem": "Gift Card",
    "done": "Done",
    "copiedToClipboard": "Code copied to clipboard",
    "paymentDetails": "Payment Details",
    "close": "Close",
    "accessibility": {
      "closeHint": "Closes the gift card"
    }
  },
  "ProfessionalCard": {
    "anyProfessional": "Choose a service first",
    "bookWithAnyProfessional": "Book with any professional",
    "professionalFallback": "Professional",
    "giftCard": {
      "title": "Buy a gift card",
      "subtitle": "Give the gift of grooming",
      "accessibility": {
        "label": "Buy a gift card",
        "hint": "Opens gift card purchase"
      }
    },
    "availability": {
      "available": "Available {{date}}",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "notAvailable": "Not Available"
    },
    "infoIcon": {
      "accessibility": {
        "label": "View professional information",
        "hint": "Opens details and Instagram photos"
      }
    },
    "accessibility": {
      "selectAnyProfessional": "Select any professional for your appointment",
      "selectProfessional": "Select {{name}} as your professional",
      "selectThisProfessional": "Select this professional",
      "currentlySelected": "Currently selected. Tap to deselect.",
      "tapToSelect": "Tap to select this professional for your appointment."
    }
  },
  "ProfessionalPasscodeBottomSheet": {
    "title": "Enter Passcode",
    "unlocked": "Unlocked",
    "verifying": "Verifying...",
    "subtitle": "This professional requires a passcode to book",
    "placeholder": "Enter passcode",
    "submit": "Unlock",
    "cancel": "Cancel",
    "error": {
      "invalid": "Invalid passcode. Please try again.",
      "incorrectPassword": "Incorrect password",
      "network": "Network error. Please try again."
    },
    "accessibility": {
      "input": "Passcode input field",
      "submit": "Submit passcode to unlock booking",
      "cancel": "Cancel passcode entry and go back"
    }
  },
  "ProfessionalInfoBottomSheet": {
    "title": "{{name}}",
    "viewOnInstagram": "See more on Instagram",
    "accessibility": {
      "close": "Close professional information",
      "instagramImage": "Instagram photo {{index}} of {{total}}",
      "closeHint": "Closes the professional details"
    }
  },
  "ProfessionalInstagramGallery": {
    "counter": "{{current}} / {{total}}",
    "accessibility": {
      "back": "Back to photo grid",
      "image": "Instagram photo {{index}}",
      "thumbnail": "View Instagram photo {{index}}"
    }
  },
  "ChooseServiceCategoryScreen": {
    "title": "Choose a service",
    "empty": {
      "message": "There are no services available to book right now"
    }
  },
  "ChooseServiceSubcategoryScreen": {
    "title": "Choose a service",
    "empty": {
      "message": "There are no services available to book right now"
    }
  },
  "CategoryUnavailable": {
    "title": "This category isn't available",
    "description": "We couldn't find any services here right now. Try picking another option.",
    "backToCategories": "Back to categories",
    "backToSubcategories": "Back to subcategories"
  },
  "ChooseServiceScreen": {
    "title": "Choose a service",
    "categoryHeading": "{{name}} services",
    "ok": "OK",
    "cartCreationFailed": "Cart Creation Failed",
    "cartCreationError": "Unable to create cart: {{message}}. Please try again.",
    "loading": {
      "servicesText": "Loading services...",
      "findingServicesFor": "Finding services for",
      "anyProfessional": "any professional"
    },
    "error": {
      "title": "Unable to load services",
      "message": "There was a problem loading services. Please try again later.",
      "tryAgain": "Try Again"
    },
    "accessibility": {
      "closeButton": "Close service selection",
      "closeButtonHint": "Closes the service selection screen and returns to previous screen"
    }
  },
  "CategorySelect": {
    "placeholder": "Select Category",
    "all": "All categories",
    "uncategorized": "Uncategorized"
  },
  "ServiceCategoryBreadcrumb": {
    "anyProfessional": "Any"
  },
  "ServiceCategoryRow": {
    "servicesCount_one": "{{count}} service",
    "servicesCount_other": "{{count}} services"
  },
  "ServiceGrid": {
    "additionalServicesTitle": "Anything you wish to add?",
    "yourServicesTitle": "Your services",
    "yourAddonsTitle": "Your add-ons",
    "otherServicesTitle": "Other services",
    "error": {
      "title": "Unable to load services",
      "message": "There was a problem loading services. Please try again later."
    },
    "empty": {
      "filtered": {
        "title": "No services in this category",
        "message": "Try selecting a different category or \"All\" to see more services."
      },
      "unfiltered": {
        "title": "No services available",
        "message": "There are currently no available services at this location."
      }
    },
    "categoryFilterPlaceholder": "Filter by category",
    "addonCategoryLabel": "Add-ons"
  },
  "ViewOrderBar": {
    "viewOrder": "View Order",
    "goToCheckout": "Go to checkout",
    "itemCount": {
      "one": "1 item",
      "other": "{{count}} items"
    },
    "accessibility": {
      "expandHint": "Tap to expand order details",
      "orderSummary": "Order summary: {{itemCount}}, {{totalPrice}}"
    },
    "continue": "Continue"
  },
  "ViewOrderCartPromo": {
    "saving": "Saving {{amount}} with promotion",
    "useBy": "Use by {{date}}"
  },
  "ViewOrderDepositCard": {
    "title": "Deposit due today",
    "refundable": "Holds your appointment. Applied to your service, and refundable.",
    "nonRefundable": "Holds your appointment. Applied to your service. Non-refundable."
  },
  "ViewOrderBottomSheet": {
    "depositDueToday": "Deposit due today",
    "title": "Your Order",
    "shopNamePlaceholder": "Barbershop",
    "anyProfessional": "Any Professional",
    "addGuest": "Add guest to order",
    "checkoutAllAtOnce": "Checkout all at once",
    "groupOrderLimitReached": "Group order limit reached",
    "groupOrderLimitDescription": "You can add up to 5 appointments",
    "subtotal": "Subtotal",
    "chooseTime": "Choose a time",
    "nextAvailableTime": "Next available time",
    "addButton": "Add",
    "tip": "Tip",
    "tipTooltip": "Preliminary tip for your professional.\nCan be adjusted after the appointment, reflecting your overall experience.",
    "tipTooltipGroup": "Preliminary tip for your professional.\nTipping for the same professional can only be applied once.",
    "guestAppointment": "Guest appointment",
    "waitlistMeFor": "Waitlist me for {{date}}",
    "joinWaitlistFor": "Join waitlist for {{date}}",
    "preferredTime": "Preferred time",
    "accessibility": {
      "closeOrderSummary": "Close order summary",
      "closeOrderSummaryHint": "Tap to close the order summary",
      "addGuestButton": "Add guest to group appointment",
      "editOrder": "Edit order"
    }
  },
  "EditOrderBottomSheet": {
    "title": "Edit order",
    "done": "Done",
    "location": "Location",
    "professional": "Professional",
    "services": "Services",
    "dateTime": "Date & time",
    "anyProfessional": "Any Professional",
    "guestAppointment": "Guest appointment",
    "accessibility": {
      "editLocation": "Edit location",
      "editProfessional": "Edit professional",
      "editServices": "Edit services",
      "editTime": "Edit date and time",
      "removeAddon": "Remove {{name}}"
    }
  },
  "PriceRangeTooltip": {
    "content": "Professionals set their own prices, so this is the range across the team. Pick a professional to see their exact price.",
    "accessibilityLabel": "Price range information"
  },
  "ServiceCard": {
    "giftCard": {
      "title": "Gift card",
      "fromPrice": "from {{price}}",
      "accessibility": {
        "label": "Gift card, {{fromPrice}}",
        "hint": "Opens gift card purchase"
      }
    },
    "duration": {
      "minutes": "min",
      "hours": "h",
      "minutesShort": "m"
    },
    "action": {
      "addService": "Add service",
      "removeService": "Remove service"
    },
    "badge": {
      "addon": "Add-on"
    },
    "description": {
      "moreDetails": "More details",
      "lessDetails": "Less details"
    },
    "accessibility": {
      "serviceInformation": "Service information",
      "hideDescription": "Hide service description",
      "showDescription": "Show service description",
      "serviceDetails": "Service: {{name}}, Duration: {{duration}}, Price: {{price}}",
      "currentlySelected": "Currently selected service",
      "tapToSelect": "Tap to select this service"
    }
  },
  "ChooseTimeGuestSection": {
    "anyProfessional": "Any professional",
    "noAvailableTimes": "No available times",
    "noTimesAvailable": "No times available",
    "oneTimeAvailable": "1 time available",
    "timesAvailable": "{{count}} times available",
    "suggestedForYou": "Suggested for you",
    "duration": {
      "hours": "hr",
      "hoursPlural": "hrs",
      "minutes": "min"
    }
  },
  "ViewOrderBottomSheetActions": {
    "accessibility": {
      "chooseTimeButton": "Choose a time button",
      "chooseTimeButtonHint": "Tap to choose a time",
      "nextAvailableTimeButton": "Next available time button",
      "nextAvailableTimeButtonHint": "Tap to choose the next available time",
      "continueButton": "Continue button",
      "continueButtonHint": "Tap to continue"
    },
    "continue": "Continue",
    "waitlistDisclaimer": "Card on file is required in order to be placed on the waiting list. Charges apply only if you accept a reservation."
  },
  "TimeSlotButton": {
    "accessibility": {
      "tapToSelect": "Tap to select this time",
      "notAvailable": "This time is not available"
    }
  },
  "ChooseTimeSlotGrid": {
    "showAll": "Show all",
    "showLess": "Show less",
    "accessibility": {
      "showAllTimes": "Show all times",
      "showLessTimes": "Show less times"
    }
  },
  "ChooseTimeCalendarDay": {
    "accessibility": {
      "notAvailable": "Not available",
      "noTimesAvailable": "No times available",
      "oneTime": "1 time",
      "multipleTimes": "{{count}} times",
      "available": "available",
      "tapToSelect": "Tap to select this date"
    }
  },
  "ChooseTimeEmptyState": {
    "nextTime": "Next time",
    "noAvailability": "No availability",
    "waitlist": "Waitlist"
  },
  "WaitlistTimePreferencePicker": {
    "title": "What's your preferred time?",
    "anytime": "Anytime",
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Evening",
    "afterHours": "After hours",
    "range": {
      "morning": "9:00am - 12:00pm",
      "afternoon": "12:00pm - 5:00pm",
      "evening": "5:00pm - 8:00pm",
      "afterHours": "from 8:00pm"
    },
    "accessibility": {
      "anytime": "Anytime",
      "morning": "Morning, 9:00am to 12:00pm",
      "afternoon": "Afternoon, 12:00pm to 5:00pm",
      "evening": "Evening, 5:00pm to 8:00pm",
      "afterHours": "After hours, from 8:00pm",
      "rowHint": "Adds or removes this time from your waitlist preference",
      "anytimeHint": "Clears the other times so any time works"
    }
  },
  "StandbyWaitlistJoinSheet": {
    "title": "Join the waitlist",
    "cta": "Put me on the waitlist",
    "legalIntro": "By joining the waitlist you agree to the",
    "summary": {
      "title": "Summary",
      "joinWaitlistFor": "Join waitlist for",
      "preferredTime": "Preferred time",
      "professional": "Professional",
      "anyProfessional": "Any professional",
      "duration": "Duration",
      "total": "Total"
    },
    "accessibility": {
      "ctaHint": "Adds you to the waitlist for this day"
    }
  },
  "ChooseTimeLoadingScreen": {
    "title": "Choose a time"
  },
  "ChooseTimeScreen": {
    "title": "Choose a time",
    "processing": "Processing",
    "ok": "OK",
    "preselectDateOutsideWindow": "That date is outside the online booking window, so we couldn't select it for you",
    "error": {
      "title": "Error",
      "paymentError": "Something went wrong with the payment",
      "bookingPaymentError": "An error occurred while handling the booking payment. Please try again.",
      "alreadyOnWaitlist": "You're already on the waiting list",
      "throttled": "Too many attempts. Wait a moment and try again.",
      "standbyWaitlistUnavailable": "This waitlist isn't available right now.",
      "standbyAlreadyOnWaitlist": "You're already on the waitlist",
      "cartExpired": "Your booking session has expired. Please start your booking again.",
      "startOver": "Start Over",
      "paymentRequiredForWaitlist": "A payment method is required to join this waiting list",
      "digitalWalletNotAvailable": "Digital wallet payment method is not available",
      "digitalWalletPaymentFailed": "Payment failed",
      "digitalWalletUnexpectedError": "An unexpected error occurred",
      "timeoutTitle": "Request timed out",
      "timeoutMessage": "Your booking may have been completed. Please check your upcoming appointments before trying again.",
      "networkTitle": "Connection lost",
      "networkMessage": "Please check your internet connection and try again.",
      "paymentFailedTitle": "Payment failed",
      "paymentFailedMessage": "Your payment could not be processed. Please try a different payment method.",
      "serverErrorTitle": "Something went wrong",
      "serverErrorMessage": "An unexpected error occurred. Please try again later.",
      "deepLinkUnavailableTitle": "This isn't available",
      "deepLinkUnavailableMessage": "This service isn't available for online booking right now.",
      "goBack": "Go back"
    }
  },
  "Calendar": {
    "today": "Today",
    "accessibility": {
      "previousMonth": "Previous month",
      "nextMonth": "Next month"
    }
  },
  "CalendarDay": {
    "accessibility": {
      "today": "Today",
      "selected": "Selected",
      "notAvailable": "Not available",
      "tapToSelect": "Tap to select this date"
    }
  },
  "TipSelector": {
    "none": "None",
    "other": "Other",
    "dollarSign": "$",
    "accessibility": {
      "enterCustomTip": "Enter custom tip amount in dollars",
      "enterCustomTipHint": "Enter a custom tip amount. Current value: {{value}}",
      "dollarSign": "Dollar sign",
      "confirmButton": "Confirm tip amount{{amount}}",
      "confirmButtonHint": "{{hasAmount}}",
      "confirmButtonHintWithAmount": "Confirm the tip amount of ${{amount}}",
      "confirmButtonHintEmpty": "Enter a tip amount first, then confirm",
      "confirm": "Confirm",
      "tipSelectionOptions": "Tip selection options",
      "tipSelectionHint": "Select a tip amount for your service",
      "noTip": "No tip",
      "noTipHint": "Select to give no tip",
      "percentageTip": "{{percentage}}% tip",
      "percentageTipHint": "Select {{percentage}}% tip amounting to ${{amount}}",
      "customTip": "Custom tip of ${{amount}}",
      "customTipAmount": "Custom tip amount",
      "customTipSelected": "Currently selected custom tip amount",
      "customTipSelect": "Select to enter a custom tip amount"
    },
    "custom": "Custom"
  },
  "AdultOnlyConsent": {
    "title": "21 and over",
    "ageRestriction": "21+",
    "descriptionPrefix": "By booking an appointment you agree that",
    "descriptionSuffix": "you are 21 or over.",
    "agree": "I agree"
  },
  "CancellationPolicy": {
    "title": "Cancellation policy",
    "cannotCancelDescription": "According to the cancellation policy, you cannot cancel this appointment.",
    "cannotCancelDescriptionGiftCard": "According to the cancellation policy, you cannot cancel this order.",
    "freeCancellation": "Free cancellation until {{time}} on {{date}}"
  },
  "CancellationPolicyConsent": {
    "title": "Cancellation Policy",
    "description": "You'll have time until <strong>{{time}}</strong> on <strong>{{date}}</strong> to cancel this appointment without being charged.",
    "now": "NOW",
    "understand": "I agree"
  },
  "NotificationConsent": {
    "accessibility": {
      "sms": {
        "yes": "Yes, receive promotional text messages",
        "skip": "Skip, do not receive text messages"
      },
      "email": {
        "yes": "Yes, receive promotional emails",
        "skip": "Skip, do not receive emails"
      }
    },
    "title": "{{name}} wants to keep in touch!",
    "yes": "Yes",
    "skip": "Skip",
    "sms": {
      "description": "By clicking \"Yes\" below you agree to receive automated promotional text messages at the mobile number you'll provide.",
      "descriptionTerms": "Consent is not a condition of purchase. Text HELP for help and STOP to cancel. Msg and data rates may apply and msg rate varies. Not all carriers covered. View <modalLink>Terms & Privacy</modalLink> for more information."
    },
    "email": {
      "description": "By clicking \"Yes\" below you agree to receive promotional emails at the email address you'll provide.",
      "descriptionTerms": "Consent is not a condition of purchase. You can unsubscribe at any time using the link in any email. View <modalLink>Terms & Privacy</modalLink> for more information."
    }
  },
  "AppStoreReviewPrompt": {
    "title": "How do you like the app so far?",
    "description": "Whether you love us or have feedback, we want to know!",
    "primaryButton": "Love it!",
    "secondaryButton": "Needs work",
    "accessibility": {
      "closeButton": "Close review prompt",
      "closeButtonHint": "Dismisses this review prompt"
    }
  },
  "NPSSurveyModal": {
    "title": "Quick question",
    "question": "How likely are you to recommend SQUIRE to your friends and colleagues?",
    "fromNotLikely": "From not likely",
    "toMostLikely": "to most likely",
    "maybeLater": "Maybe later",
    "done": "Done",
    "sendFeedback": "Send feedback",
    "thankYouTitle": "Thank you!",
    "anythingElse": "Anything else you want to add?",
    "thankYouBody": "Your feedback will be used to improve our services",
    "reasonLabel": "REASON FOR YOUR SCORE",
    "reasonPlaceholder": "Enter your feedback",
    "thankYouToast": "Thank you for your time!",
    "submitError": "Failed to submit feedback. Please try again."
  },
  "TermsWebViewModal": {
    "title": "Terms of Service",
    "accessibility": {
      "closeButton": "Close terms",
      "closeButtonHint": "Closes the terms and conditions"
    }
  },
  "TermsScreen": {
    "title": "Terms of Service",
    "loading": "Loading terms...",
    "error": "Failed to load terms of service"
  },
  "WebViewScreen": {
    "errorTitle": "Failed to load content",
    "errorMessage": "Please check your internet connection and try again.",
    "accessibility": {
      "loadingContent": "Loading content",
      "closeButton": "Close",
      "closeButtonHint": "Closes the screen and returns to previous page"
    }
  },
  "PrivacyScreen": {
    "title": "Privacy Policy",
    "loading": "Loading privacy policy...",
    "error": "Failed to load privacy policy"
  },
  "ProfileScreen": {
    "editProfile": "Edit Profile",
    "phoneNotProvided": "Phone number not set",
    "editPhoneNumber": "Edit phone number",
    "setPhoneNumber": "Set phone number",
    "editEmail": "Edit email",
    "changePassword": "Change password",
    "notifications": "Notifications",
    "confirm": "Confirm",
    "reschedule": "Reschedule",
    "cancel": "Cancel",
    "deleteAccount": "Delete account",
    "firstName": "First Name",
    "lastName": "Last Name",
    "saveChanges": "Save",
    "editFirstName": "Tap to edit first name",
    "editLastName": "Tap to edit last name",
    "nameSaved": "Name updated successfully",
    "nameUpdateFailed": "Failed to update name",
    "error": "Unable to load profile",
    "tryAgain": "Try again",
    "editPhoto": {
      "uploadError": {
        "title": "Couldn't update photo",
        "message": "Something went wrong uploading your photo. Please try again."
      }
    },
    "accessibility": {
      "profileInfo": "Profile information section",
      "editPhoto": "Edit profile photo",
      "editPhoneNumberButton": "Edit phone number",
      "setPhoneNumberButton": "Set phone number",
      "editEmailButton": "Edit email",
      "changePasswordButton": "Change password",
      "notificationsButton": "Notifications settings",
      "deleteAccountButton": "Delete account",
      "deleteAccountButtonHint": "Permanently delete your account",
      "firstNameEdit": "Edit first name",
      "lastNameEdit": "Edit last name",
      "saveNameButton": "Save name changes",
      "saveChanges": "Save changes",
      "saveChangesHint": "Save the edited name"
    }
  },
  "AppointmentDetailMap": {
    "accessibility": {
      "closeButton": "Close appointment details"
    }
  },
  "AppointmentDetailShopInfo": {
    "appointmentCancelled": "Appointment cancelled",
    "getDirections": "Get directions",
    "accessibility": {
      "getDirections": "Get directions to shop"
    }
  },
  "AppointmentDetailInfo": {
    "cancelled": "Cancelled",
    "confirmationCode": "Confirmation code",
    "professional": "Professional",
    "professionalNoLongerAvailable": "No longer available",
    "service": "Service",
    "time": "Time",
    "tip": "Tip",
    "addTip": "Add a tip",
    "addToCalendar": "Add to calendar",
    "rateYourAppointment": "Rate your appointment",
    "youRatedStars": "You rated {{count}} stars",
    "calendarTitle": {
      "withShop": "{{serviceName}} at {{shopName}}",
      "withProfessional": "{{serviceName}} with {{professionalName}}"
    },
    "calendarDescription": {
      "confirmationCode": "Confirmation Code: {{confirmationCode}}",
      "professional": "Professional: {{professionalName}}",
      "service": "Service: {{serviceName}}",
      "location": "Location: {{shopName}}"
    },
    "accessibility": {
      "addToCalendar": "Add appointment to calendar",
      "addTip": "Add a tip for this appointment",
      "changeTip": "Change tip amount",
      "rateAppointmentButton": "Rate your appointment",
      "rateAppointmentButtonHint": "Tap to rate this appointment",
      "ratingDisplay": "You rated this appointment {{count}} stars",
      "starIcon": "Star {{position}} of {{total}}"
    }
  },
  "AppointmentRatingPromptModal": {
    "successMessage": "Thank you for your feedback!",
    "loadError": "Failed to load appointment data. Please try again.",
    "accessibility": {
      "closeButton": "Close rating prompt",
      "closeButtonHint": "Dismisses this rating prompt"
    }
  },
  "AppointmentRatingScreen": {
    "title": "Rate Your Appointment",
    "successMessage": "Thank you for your feedback!",
    "error": "Failed to load appointment data. Please try again.",
    "tryAgain": "Try Again",
    "step1": {
      "heading": "How was your experience with {{firstName}}?",
      "nextButton": "Next"
    },
    "step2": {
      "heading": "Thanks for rating! Anything else you want to share?",
      "inputPlaceholder": "Consider sharing details about skill, punctuality, etc.",
      "skipButton": "Skip",
      "submitButton": "Submit Review"
    },
    "accessibility": {
      "closeButton": "Close rating screen",
      "closeButtonHint": "Cancel and return to appointment details",
      "nextButton": "Continue to review step",
      "nextButtonHint": "Proceed to add an optional review",
      "skipButton": "Skip review and submit rating",
      "skipButtonHint": "Submit rating without a review",
      "submitButton": "Submit rating with review",
      "submitButtonHint": "Submit your {{count}} star rating and review",
      "starButton": "Rate {{count}} stars",
      "starButtonHint": "Select {{count}} star rating"
    }
  },
  "AppointmentDetailSummary": {
    "subtotal": "Subtotal",
    "services": "Services",
    "taxesAndFees": "Taxes & fees",
    "tax": "Tax",
    "fee": "Fee",
    "tip": "Tip",
    "total": "Total",
    "addTip": "Add a tip",
    "changeTip": "Change",
    "addCode": "Add a code",
    "promo": "Promo",
    "membership": "Membership",
    "giftCard": "Gift card",
    "accessibility": {
      "addTip": "Add a tip to your appointment",
      "changeTip": "Change tip amount",
      "addCode": "Add a promo code",
      "removePromo": "Remove promo code",
      "expandTaxes": "Expand taxes and fees breakdown",
      "collapseTaxes": "Collapse taxes and fees breakdown"
    }
  },
  "AppointmentDetailPayment": {
    "chargeDisclaimer": "You will not be charged until an hour before your appointment starts."
  },
  "AppointmentDetailActions": {
    "reschedule": "Reschedule",
    "cancel": "Cancel",
    "rebook": "Rebook",
    "rebooking": "Rebooking...",
    "rebookError": "Unable to rebook appointment",
    "rebookErrorDescription": "This order can't be rebooked at this time.",
    "barberUnavailable": "Your barber is no longer available. Choose a new one.",
    "serviceUnavailable": "Your booked service is no longer available. Choose a new one.",
    "accessibility": {
      "reschedule": "Reschedule appointment",
      "cancel": "Cancel appointment",
      "rebook": "Rebook appointment",
      "rebooking": "Rebooking..."
    }
  },
  "TipSelectionModal": {
    "title": "Change tip",
    "none": "None",
    "other": "Other",
    "confirm": "Confirm",
    "dollarSign": "$",
    "accessibility": {
      "close": "Close tip selection modal",
      "tipPercentage": "{{percentage}}% tip",
      "noTip": "No tip",
      "customTip": "Custom tip amount",
      "confirm": "Confirm tip selection",
      "dollarSign": "Dollar sign",
      "enterCustomTipHint": "Enter a custom tip amount. Current value: {{value}}",
      "confirmCustomTip": "Confirm custom tip amount",
      "closeHint": "Closes this dialog"
    }
  },
  "CalendarSelectionModal": {
    "title": "Add to calendar",
    "googleCalendar": "Google Calendar",
    "appleCalendar": "Apple iCalendar",
    "accessibility": {
      "close": "Close calendar selection modal",
      "googleCalendar": "Add appointment to Google Calendar",
      "appleCalendar": "Add appointment to Apple Calendar",
      "closeHint": "Closes this dialog"
    }
  },
  "PromoCodeModal": {
    "title": "Add a code",
    "codeLabel": "CODE",
    "codePlaceholder": "Enter your code",
    "apply": "Apply",
    "accessibility": {
      "close": "Close promo code modal",
      "codeInput": "Promo code input",
      "codeInputHint": "Enter your promo code",
      "apply": "Apply promo code"
    }
  },
  "AppointmentDetailScreen": {
    "title": "Appointment Details",
    "orderInfo": "Order info",
    "professionalNoLongerAvailable": "No longer available",
    "error": "Failed to load appointment details. Please try again.",
    "tryAgain": "Try Again",
    "accessibility": {
      "closeButton": "Close appointment details",
      "closeButtonHint": "Return to appointments list"
    }
  },
  "ViewReservationContentWrapper": {
    "confirmation": {
      "title": "{{name}}, your appointment is confirmed.",
      "titleGeneric": "Your appointment is confirmed.",
      "orderTitle": "{{name}}, your order is confirmed.",
      "orderTitleGeneric": "Your order is confirmed."
    },
    "canceled": {
      "title": "Appointment canceled",
      "orderTitle": "Order canceled"
    },
    "totalPrice": "Total price",
    "taxes": "Taxes",
    "fee": "Fee",
    "giftCard": "Gift Card",
    "promo": "Promo",
    "membership": "Membership",
    "addToCalendar": "Add to calendar",
    "appleCalendar": "iCalendar",
    "googleCalendar": "Google",
    "yahooCalendar": "Yahoo",
    "actions": {
      "reschedule": "Reschedule appointment",
      "cancel": "Cancel appointment",
      "scheduleAnother": "Schedule another appointment"
    },
    "accessibility": {
      "close": "Close",
      "appleCalendar": "Add to Apple Calendar",
      "googleCalendar": "Add to Google Calendar",
      "yahooCalendar": "Add to Yahoo Calendar",
      "closeHint": "Closes the reservation details"
    }
  },
  "ViewReservationAppointmentCard": {
    "confirmationCode": "Confirmation code",
    "duration": {
      "label": "Duration",
      "hours": "h",
      "minutes": "min",
      "minutesShort": "m"
    },
    "time": "Time",
    "tip": "Tip",
    "accessibility": {
      "rescheduleAppointment": "Reschedule appointment"
    }
  },
  "ViewReservationPaymentStatus": {
    "pay": "Pay",
    "applePay": "Apple Pay",
    "creditCard": "Credit card",
    "giftCard": "Gift card",
    "payInPerson": "Pay in person",
    "pending": "PENDING PAYMENT",
    "canceled": "CANCELLED",
    "paid": "PAID",
    "disclaimer": "You will not be charged until an hour before your appointment starts.",
    "canceledNotCharged": "You weren't charged due to a cancelation of this appointment.",
    "canceledCharged": "You were charged despite canceling the appointment due to a Cancelation Policy of {{shopName}}."
  },
  "ViewReservationErrorFallback": {
    "title": "Error loading reservation",
    "retry": "Try Again",
    "takeMeHome": "Take me home"
  },
  "ViewReservationShopInfo": {
    "getDirections": "Get directions",
    "accessibility": {
      "getDirections": "Get directions to shop",
      "mapPreview": "Map preview of shop location"
    }
  },
  "ViewWaitlistContentWrapper": {
    "confirmation": {
      "title": "{{name}}, waiting list is confirmed!",
      "titleGeneric": "Waiting list is confirmed!"
    },
    "header": {
      "available": "A slot is available for {{barber}} for {{date}}",
      "expired": "{{barber}} waiting list for {{date}} expired",
      "removed": "You've been removed from the waiting list",
      "readyToBook": "Appointment with {{barber}} for {{date}} is ready to book"
    },
    "badge": {
      "waitingList": "Waiting list",
      "slotsAvailable": "{{count}} slots available",
      "expired": "Waiting list expired",
      "chooseTime": "Choose a time",
      "chooseDifferentTime": "Choose a different date and time"
    },
    "position": {
      "title": "You're in position {{position}}",
      "subtitle": "on the waiting list for {{name}}",
      "notify": "We'll notify you if a slot opens"
    },
    "actions": {
      "book": "Book",
      "reschedule": "Reschedule",
      "leaveWaitlist": "Leave waitlist"
    },
    "accessibility": {
      "close": "Close",
      "closeHint": "Closes the waitlist details"
    },
    "errors": {
      "bookingFailed": "Failed to book appointment. Please try again.",
      "rescheduleFailed": "Failed to reschedule. Please try again.",
      "slotsFetchFailed": "Failed to load available times. Please try again."
    }
  },
  "LeaveWaitlistModal": {
    "title": "Leave waiting list?",
    "message": "You'll lose your spot on the waiting list. You can rejoin at any time.",
    "leave": "Leave waiting list",
    "leaving": "Leaving...",
    "keep": "Keep my spot",
    "accessibility": {
      "close": "Close",
      "leave": "Leave waiting list",
      "keep": "Keep my spot",
      "closeHint": "Closes this dialog"
    },
    "errors": {
      "leaveFailed": "Failed to leave waiting list. Please try again."
    }
  },
  "ViewWaitlistCard": {
    "duration": "Duration",
    "durationValue": "{{minutes}} min",
    "date": "Date",
    "time": "Time",
    "tip": "Tip",
    "total": "Total price",
    "chooseTime": "Choose a time",
    "chooseDifferentTime": "Choose a different date and time"
  },
  "WaitlistTimeSlotsSheet": {
    "title": "Available times for {{date}}",
    "confirm": "Confirm"
  },
  "WaitlistRescheduleSheet": {
    "title": "Choose a different date and time",
    "confirm": "Confirm"
  },
  "WaitlistRescheduleScreen": {
    "title": "Choose a time",
    "rescheduleButton": "Confirm",
    "successMessage": "Rescheduled successfully",
    "errorMessage": "Failed to reschedule. Please try again.",
    "noTimeSelected": "Please select a time"
  },
  "EditPhoneNumberBottomSheet": {
    "editTitle": "Edit phone number",
    "setTitle": "Set phone number",
    "phoneLabel": "PHONE",
    "phonePlaceholder": "Enter phone number",
    "sendCodeButton": "Send Code",
    "verifyTitle": "Verify your phone number",
    "verifyDescription": "We have sent a 6-digit verification code to phone ending in {{last4}}",
    "sendingCode": "Sending verification code...",
    "codeSent": "Code sent",
    "validCode": "Code verified",
    "invalidCode": "Invalid verification code. Please try again.",
    "sendCodeError": "Failed to send verification code",
    "sendCodeErrorDescription": "Please try again or contact support if the problem persists.",
    "enterCodeLabel": "ENTER CODE",
    "resendCodeButton": "Resend the code",
    "otpCode": "Code",
    "didNotReceiveText": "Didn't receive anything? Try again.",
    "accessibility": {
      "phoneInput": "Phone number input",
      "phoneInputHint": "Enter your phone number",
      "sendCodeButton": "Send Code",
      "sendCodeButtonHint": "Send a 6-digit verification code to your phone",
      "saveButtonHint": "Save changes to your phone number",
      "otpInput": "Verification code input",
      "otpInputHint": "Enter the 6-digit verification code",
      "resendButton": "Resend verification code",
      "resendButtonHint": "Resend the verification code to your phone"
    }
  },
  "CancelOrderModal": {
    "title": "Cancel order",
    "message": "Are you sure you want to cancel this order? Please note that this will cancel all associated appointments.",
    "cancel": "Cancel",
    "canceling": "Canceling...",
    "keep": "Keep",
    "accessibility": {
      "close": "Close cancel order modal",
      "cancel": "Cancel order",
      "keep": "Keep order",
      "closeHint": "Closes this dialog"
    }
  },
  "ConfirmBookingBottomSheet": {
    "title": "Confirm Booking",
    "haveAccount": "Have an account?",
    "signIn": "Sign in",
    "paymentMethod": "Payment method",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "creditOrDebitCard": "Card or bank account",
    "payInPerson": "Pay in person",
    "cashApp": "Cash App",
    "buyNowPayLaterWith": "Buy now, pay later with {{provider}}",
    "bnplProvider": {
      "klarna": "Klarna",
      "affirm": "Affirm",
      "afterpay_clearpay": "Afterpay"
    },
    "payNow": "Pay now",
    "payLater": "Pay later",
    "afterpay": "Afterpay",
    "summary": "Summary",
    "services": "Services",
    "tips": "Tips",
    "taxes": "Taxes & Fees",
    "total": "Total",
    "addPromoCode": "Add a code",
    "promoCode": "Promo Code",
    "giftCard": "Gift Card",
    "membership": "Membership",
    "taxesLabel": "Taxes",
    "feesLabel": "Fees",
    "feesDescription": "This is a convenience fee that is collected by SQUIRE. The amount varies based on services in your cart.",
    "feesDescriptionWithBarbershop": "This is a convenience fee collected by SQUIRE and your barbershop.",
    "waitlistFeeLabel": "Waitlist fee",
    "waitlistFeeDescription": "This fee is charged when joining the waiting list.",
    "paymentRequiredForWaitlist": "Card on file is required to join waiting list.",
    "yourCardWillBeChargedToday": "Your card will be charged today",
    "book": "Book",
    "booking": "Booking",
    "joinWaitlist": "Put me on the waiting list",
    "legalText": "By booking an appointment you agree to the",
    "termsOfService": "Terms of Service",
    "and": "and the",
    "privacyPolicy": "Privacy Policy",
    "userInformation": {
      "title": "Your information",
      "firstNameLabel": "FIRST NAME",
      "firstNamePlaceholder": "First name *",
      "lastNameLabel": "LAST NAME",
      "lastNamePlaceholder": "Last name *",
      "phoneLabel": "PHONE",
      "phonePlaceholder": "Phone *",
      "emailLabel": "EMAIL",
      "emailPlaceholder": "Email *",
      "validation": {
        "firstNameRequired": "First name is required",
        "firstNameInvalid": "First name can't contain numbers",
        "lastNameRequired": "Last name is required",
        "lastNameInvalid": "Last name can't contain numbers",
        "phoneInvalid": "Please enter a valid phone number",
        "emailInvalid": "Please enter a valid email address",
        "emailRequired": "Email is required",
        "paymentMethodRequired": "Please select a payment method"
      },
      "accessibility": {
        "firstNameInput": "First name",
        "lastNameInput": "Last name",
        "phoneInput": "Phone number",
        "phoneInputHint": "Enter your phone number with country code",
        "emailInput": "Email address"
      }
    },
    "accessibility": {
      "shopImage": "Photo of {{name}}",
      "paymentMethod": "{{method}} payment method",
      "paymentMethodHint": "Select {{method}} as your payment method",
      "bookButton": "Book appointment",
      "bookButtonHint": "Confirm and book your appointment",
      "loading": "Loading"
    }
  },
  "RescheduleAppointmentScreen": {
    "title": "Reschedule",
    "currentAppointment": "Current appointment",
    "minutesAbbreviation": "min",
    "newAppointment": "New appointment",
    "selectNewTime": "Select a new date and time",
    "rescheduleButton": "Reschedule",
    "cancelButton": "Cancel",
    "successMessage": "Appointment rescheduled successfully",
    "error": "Failed to load appointment data. Please try again.",
    "tryAgain": "Try Again",
    "errorMessage": "Failed to reschedule appointment",
    "errorDescription": "Please try again or contact support",
    "sameTimeError": "Please select a different time",
    "noTimeSelected": "Please select a new time",
    "pastTimeError": "Cannot select a time in the past",
    "loadingSchedule": "Loading available times...",
    "noAvailableTimes": "No available times for this date",
    "barberDoesNotAllowReschedule": "This barber doesn't allow rescheduling within this timeframe",
    "timeSlotUnavailable": "This time slot is no longer available",
    "cannotReschedulePast": "Cannot reschedule past appointments",
    "accessibility": {
      "rescheduleButton": "Reschedule appointment to selected time",
      "backButton": "Cancel and go back"
    }
  },
  "CashAppBottomSheet": {
    "title": "Scan with Cash App",
    "timeRemaining": "Time remaining",
    "instructions": "Open Cash App on your phone and scan this QR code to complete your payment",
    "troubleshooting": "Having trouble? Make sure you have Cash App installed and are logged in.",
    "qrCodeExpired": "QR Code expired",
    "qrCodeExpiredDescription": "The QR code has expired. Please click on Retry to generate a new QR code.",
    "retry": "Retry",
    "openInCashApp": "or click here to open Cash App",
    "error": {
      "loadingQRCode": "Failed to load QR code. Please try again."
    },
    "accessibility": {
      "closeButton": "Close Cash App payment",
      "closeButtonHint": "Close the Cash App QR code scanner",
      "qrCode": "Cash App payment QR code"
    }
  },
  "CheckoutFormBottomSheet": {
    "cardDetails": "Card details",
    "cardOnFileRequired": "Card on file required",
    "book": "Book",
    "booking": "Booking",
    "buyGiftCard": "Buy gift card",
    "buyingGiftCard": "Buying gift card",
    "pay": "Pay",
    "joinWaitlist": "Put me on the waiting list"
  },
  "LegalBottomSheet": {
    "termsTitle": "Terms of Service",
    "privacyTitle": "Privacy Policy",
    "errorTitle": "Failed to load content",
    "errorMessage": "Please check your internet connection and try again."
  },
  "ReferralBanner": {
    "accessibilityLabel": "Become a brand ambassador and earn money",
    "eyebrow": "Brand ambassadorship",
    "headline": "Become a brand\nambassador and\nearn money!"
  },
  "ReferralWebViewScreen": {
    "title": "Referral program",
    "loadingLabel": "Loading referral program"
  },
  "CookieConsent": {
    "thisSiteUsesCookie": "This site uses cookies",
    "manageYourPrivacyChoices": "Manage your privacy choices",
    "here": "here",
    "accept": "Accept",
    "consentTab": "Consent",
    "detailsTab": "Details",
    "aboutTab": "About",
    "consentContent": "We use cookies to improve user experience and analyze website traffic. For these reasons, we may also share information about your use of our site with our analytics partners. By clicking Allow All, you consent to store on your device all the technologies described in our Cookies Policy. You can change your cookie settings by clicking Customize.",
    "detailsContent": "Details",
    "aboutContent": "Cookies are small text files that websites can use to make a user's experience more efficient. The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies, we need your permission. This site uses different types of cookies. Some cookies are placed by third-party services that appear on our pages. For more information about our use of cookies, you can view our Cookies Policy. Check out our Cookies Policy. Learn more about who we are, how you can contact us, and how we process personal data in our Privacy Policy. Check out our",
    "privacyPolicyLink": "Privacy Policy",
    "denyButton": "Deny",
    "rejectButton": "Dismiss",
    "allowSelection": "Allow selection",
    "manage": "Manage",
    "allowAllButton": "Allow All"
  },
  "CookieConsentDetails": {
    "trackerCount": "{{count}} trackers",
    "trackerCount_one": "{{count}} tracker",
    "trackerCount_other": "{{count}} trackers",
    "toggleCategory": "Toggle {{category}}",
    "denyButton": "Deny",
    "allowSelectionButton": "Allow selection",
    "allowAllButton": "Allow all",
    "backButton": "Back",
    "expiry": "Expiry",
    "type": "Type",
    "month": "{{count}} month",
    "month_one": "{{count}} month",
    "month_other": "{{count}} months",
    "year": "{{count}} year",
    "year_one": "{{count}} year",
    "year_other": "{{count}} years",
    "minute": "{{count}} minute",
    "minute_one": "{{count}} minute",
    "minute_other": "{{count}} minutes",
    "hour": "{{count}} hour",
    "hour_one": "{{count}} hour",
    "hour_other": "{{count}} hours",
    "categories": {
      "necessary": {
        "title": "Necessary",
        "description": "We use necessary cookies to help make our website the most user-friendly, enabling the navigation of the booking experience, scheduling services, and making payments."
      },
      "statistical": {
        "title": "Statistical",
        "description": "We use statistical cookies to help us understand how you interact with our website by collecting and reporting information anonymously."
      }
    },
    "trackers": {
      "stripe": {
        "name": "Stripe",
        "description": "We use Stripe for payment processing and store its cookies to ensure proper functioning.",
        "__stripe_sid": {
          "description": "Set by Stripe for fraud prevention."
        },
        "__stripe_mid": {
          "description": "Set by Stripe for fraud prevention."
        },
        "m": {
          "description": "Set by Stripe for fraud prevention."
        },
        "cookie-perms": {
          "description": "Stores your cookie consent preferences."
        }
      },
      "google": {
        "name": "Google",
        "description": "We use Google for various services such as Google Pay and Google Calendar and store its cookies to ensure proper functioning.",
        "G_ENABLED_IDPS": {
          "description": "Set by Google to enable Single Sign On."
        },
        "NID": {
          "description": "Set for the proper functioning of Google services."
        },
        "1P_JAR": {
          "description": "Set for the proper functioning of Google services."
        },
        "SID": {
          "description": "Set for the proper functioning of Google services."
        },
        "SSID": {
          "description": "Set for the proper functioning of Google services."
        },
        "HSID": {
          "description": "Set for the proper functioning of Google services."
        },
        "SIDCC": {
          "description": "Set for the proper functioning of Google services."
        },
        "APISID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-1PSID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-1PAPISID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-3PAPISID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-3PSID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-3PSIDCC": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-APISID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-HSID": {
          "description": "Set for the proper functioning of Google services."
        },
        "__Secure-SSID": {
          "description": "Set for the proper functioning of Google services."
        }
      },
      "cloudflare": {
        "name": "Cloudfare",
        "description": "We use Cloudflare to ensure a pleasant user experience and store various cookies to maximize network resources, manage traffic, and protect our sites from malicious traffic.",
        "__cf_bm": {
          "description": "Set for the proper functioning of Bot Management or Bot Fight functionality."
        }
      },
      "google-analytics": {
        "name": "Google Analytics",
        "description": "We use Google Analytics to understand how visitors interact with our website.",
        "DV": {
          "description": "Set by Google Analytics to collect information about how visitors use our site."
        },
        "OTZ": {
          "description": "Set by Google Analytics to collect information about how visitors use our site."
        },
        "_gat": {
          "description": "Set by Google Analytics to throttle request rate."
        },
        "_gid": {
          "description": "Set by Google Analytics to distinguish users."
        }
      },
      "facebook-pixel": {
        "name": "Facebook Pixel",
        "description": "We use Facebook Pixel to measure advertising effectiveness and deliver relevant ads.",
        "_fbp": {
          "description": "Set by Facebook to deliver advertising and track conversions."
        },
        "fr": {
          "description": "Set by Facebook to deliver advertising and measure ad performance."
        },
        "datr": {
          "description": "Set by Facebook to identify web browsers for security purposes."
        }
      }
    }
  },
  "DeleteServiceConfirmationBottomSheet": {
    "removeService": {
      "subtitle": "Removing this service will also remove the following add-ons, as they require a primary service.",
      "confirm": "Remove service and add-ons",
      "dismiss": "Keep everything"
    }
  },
  "BnplBottomSheet": {
    "title": "Buy now, pay later",
    "stripeNotReady": "Payment service is not ready. Please try again.",
    "failedToCreateIntent": "Could not start payment. Please try again.",
    "missingCustomerInfo": "Unable to process payment. Please try again.",
    "missingCustomer": "Customer information is missing. Please try again.",
    "next": "Next"
  },
  "BnplReturnScreen": {
    "loading": "Processing",
    "sessionExpired": "Your session has expired",
    "error": "Something went wrong",
    "cancelledToast": "Payment was cancelled or failed",
    "goHome": "Go home"
  },
  "ManageNotificationsBottomSheet": {
    "title": "Manage notifications",
    "save": "Save",
    "confirm": "Confirmation",
    "reschedule": "Reschedule",
    "cancel": "Cancellation",
    "errorMessage": "Failed to update notifications. Please try again.",
    "pushNotifications": "Push Notifications",
    "pushEnabled": "Enabled",
    "pushDisabled": "Disabled"
  },
  "NotificationSectionRow": {
    "phone": "SMS",
    "email": "Email",
    "push": "Push"
  },
  "CashAppReturnScreen": {
    "loading": "Processing",
    "sessionExpired": "Your session has expired. Please try again.",
    "error": "Something went wrong. Please try again.",
    "cancelledToast": "Payment was cancelled.",
    "goHome": "Go Home"
  },
  "AccountDeletion": {
    "choice": {
      "title": "Do you want to disable or delete your account?",
      "disable": {
        "title": "Disable account",
        "description": "We will disable your account(s) with apps powered by Squire."
      },
      "delete": {
        "title": "Delete account",
        "description": "We will erase all of your data from all apps and services powered by Squire."
      },
      "cancel": "Cancel",
      "continue": "Continue"
    },
    "disable": {
      "header": "Are you sure you want to disable your account?",
      "cards": {
        "0": {
          "title": "Your account will be disabled",
          "description": "We will disable your Squire account and you will no longer be able to login to any service powered by Squire."
        },
        "1": {
          "title": "Barbers may still access your data",
          "description": "Your barber may still contact you about appointments or send you marketing messages."
        },
        "2": {
          "title": "Future appointments will not be canceled",
          "description": "All of your future appointments and memberships will still be active."
        },
        "3": {
          "title": "It's possible to restore your account",
          "description": "To restore your account, please contact techsupport@getsquire.com"
        }
      },
      "primary": "Disable account",
      "secondary": "Keep account"
    },
    "delete": {
      "header": "Are you sure you want to delete your account?",
      "cards": {
        "0": {
          "title": "All your data will be deleted",
          "description": "We will erase all of your data from all Squire apps and services, including any barber branded apps powered by Squire."
        },
        "1": {
          "title": "Not responsible for future contact",
          "description": "We are not responsible if your barber continues to independently contact you."
        },
        "2": {
          "title": "Appointments will be cancelled",
          "description": "All of your future appointments and any memberships will be canceled. Your barber's cancellation policy still applies."
        },
        "3": {
          "title": "It's permanent",
          "description": "Once deleted, this cannot be undone."
        }
      },
      "primary": "Delete account",
      "secondary": "Keep account"
    },
    "toast": {
      "successDisabled": "Your account was successfully disabled",
      "successDeleted": "Your account was successfully deleted",
      "error": "Something went wrong"
    }
  },
  "StandbyRegistrationScreen": {
    "branding": {
      "headline": "Join the waitlist.",
      "poweredBy": "Powered by"
    },
    "closed": {
      "title": "Waitlist is closed.",
      "bookButton": "Book next appointment",
      "bookButtonHint": "Opens this shop's booking page"
    },
    "enterPhone": {
      "title": "Enter your phone",
      "subtitle": "We'll check to see if you already have an account.",
      "phoneLabel": "Phone",
      "placeholder": "(555) 123-4567",
      "invalid": "Enter a valid phone number"
    },
    "footnote": {
      "sms": "By continuing, you agree to receive texts from SQUIRE at the number provided. Message and data rates may apply.",
      "legal": "By continuing, you agree to the <tosLink>Terms of Service</tosLink> and the <privacyLink>Privacy Policy</privacyLink>, including receiving transactional and marketing messages from SQUIRE."
    },
    "otp": {
      "title": "Enter the code",
      "subtitle": "Enter the 6-digit code we sent to your phone.",
      "error": "That code didn't work. Try again.",
      "expired": "That code has expired. Request a new one below."
    },
    "confirmSession": {
      "title": "Continue as {{firstName}}?",
      "subtitle": "We found an existing session on this device.",
      "confirm": "Yes, that's me",
      "notYou": "Not you?",
      "exitTitle": "Exit waitlist?",
      "exitSubtitle": "Going back leaves the waitlist sign-up. You'll need to verify your phone number again to start over.",
      "exitStay": "Stay and continue",
      "exitLeave": "Exit and start over"
    },
    "details": {
      "title": "Add your details",
      "eyebrow": "Looks like you're new here",
      "firstName": "First name",
      "firstNamePlaceholder": "Derek",
      "lastName": "Last name",
      "lastNamePlaceholder": "Jackson",
      "email": "Email",
      "emailPlaceholder": "email@squire.com",
      "phone": "Phone",
      "birthday": "Birthday",
      "birthdayPlaceholder": "MM/DD/YYYY",
      "avatarLabel": "Add a profile photo",
      "errors": {
        "birthdayRequired": "Enter your birthday",
        "birthdayInvalid": "Enter a valid date"
      }
    },
    "cta": {
      "continue": "Continue",
      "back": "Back",
      "close": "Close"
    },
    "unavailable": {
      "title": "This page isn't available",
      "genericBody": "This waitlist isn't available right now.",
      "disabledBody": "This shop isn't taking waitlist entries right now.",
      "errorTitle": "Something went wrong",
      "errorBody": "We couldn't load this page.",
      "retry": "Try again"
    },
    "errors": {
      "throttled": "Too many attempts. Wait a moment and try again.",
      "submit": "Something went wrong. Please try again."
    },
    "accessibility": {
      "backButton": "Back",
      "backButtonHint": "Returns to the previous step",
      "closeButton": "Close",
      "closeButtonHint": "Closes verification and returns to the phone step",
      "phoneInput": "Phone number",
      "phoneInputHint": "Enter your mobile number to receive a verification code",
      "phoneContinueButton": "Continue",
      "phoneContinueButtonHint": "Sends a verification code to your phone",
      "otpInput": "Verification code",
      "otpInputHint": "Enter the 6-digit code sent to your phone",
      "otpContinueButton": "Verify",
      "otpContinueButtonHint": "Verifies the code you entered",
      "detailsContinueButton": "Continue",
      "detailsContinueButtonHint": "Joins the waitlist with your details",
      "birthdayInput": "Date of birth",
      "birthdayInputHint": "Enter your date of birth as month, day, and year",
      "confirmButton": "Continue",
      "confirmButtonHint": "Continues with your signed-in account",
      "notYouButton": "Not you?",
      "notYouButtonHint": "Signs out so you can use a different phone number",
      "exitStayButton": "Stay and continue",
      "exitStayButtonHint": "Stays in the waitlist sign-up and continues",
      "exitLeaveButton": "Exit and start over",
      "exitLeaveButtonHint": "Leaves the waitlist sign-up; you'll need to verify your phone number again",
      "retryButton": "Try again",
      "retryButtonHint": "Reloads the waitlist page"
    }
  },
  "StandbyStylistScreen": {
    "title": "Select stylist",
    "anyTitle": "Any professional",
    "anySubtitle": "Auto-assign by availability",
    "continue": "Continue",
    "error": "We couldn't load stylists.",
    "retry": "Try again",
    "empty": "No stylists available.",
    "accessibility": {
      "continueButton": "Continue",
      "continueButtonHint": "Continues to service selection",
      "retryButton": "Try again",
      "retryButtonHint": "Reloads the stylist list"
    }
  },
  "StandbySummaryScreen": {
    "title": "Summary",
    "stylistLabel": "Stylist",
    "serviceLabel_one": "Service",
    "serviceLabel_other": "Services",
    "priceLabel": "Price",
    "durationLabel": "Duration",
    "error": "Couldn't load your summary",
    "retry": "Try again",
    "join": "Join waitlist",
    "joinError": "Could not join the waitlist. Try again.",
    "alreadyOnListToast": "You are already on today's waitlist.",
    "accessibility": {
      "joinButton": "Join waitlist",
      "joinButtonHint": "Submits your join request",
      "retryButton": "Try again",
      "retryButtonHint": "Reloads your summary"
    }
  },
  "StandbyServiceScreen": {
    "title": "Select service",
    "searchPlaceholder": "Search services",
    "categoryAll": "All",
    "categoryCount": "{{name}} ({{count}})",
    "continue": "Continue",
    "empty": "No services available.",
    "filteredEmpty": "No services match your search.",
    "error": "We couldn't load services.",
    "retry": "Try again",
    "durationMinutes": "{{count}} min",
    "durationHours": "{{count}} hr",
    "durationHourMinutes": "{{hours}} hr {{minutes}} min",
    "accessibility": {
      "continueButton": "Continue",
      "continueButtonHint": "Continues to the summary",
      "retryButton": "Try again",
      "retryButtonHint": "Reloads the service list"
    }
  },
  "StandbyEntriesScreen": {
    "title": "Waitlist",
    "closeButton": "Close waitlist",
    "closeButtonHint": "Returns to the previous screen",
    "subtitle": {
      "any": "Waiting for any professional",
      "waitingFor": "Waiting for {{name}}"
    },
    "offer": "{{time}} with {{name}}",
    "empty": "You're not on any waitlist",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "errorToast": "We couldn't load your waitlist. Try again.",
    "accessibility": {
      "row": "Opens this waitlist entry",
      "countdown": "Offer expires in {{time}}"
    }
  },
  "StandbyEntryStatusScreen": {
    "waiting": {
      "title": "You're on the list",
      "subtitle": "When a spot opens up, we'll notify you so you can accept and pay, or decline and stay on the list."
    },
    "offer": {
      "title": "We found you a spot",
      "subtitle": "Accept to book and proceed to payment, or decline to stay on the list and wait for another opening.",
      "countdown": "Waiting your response ({{time}})",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "professionalLabel": "Professional",
      "dateToday": "Today, {{date}}",
      "dateTomorrow": "Tomorrow, {{date}}",
      "accept": "Accept & pay",
      "decline": "Decline & stay on list"
    },
    "declined": {
      "heading": "You're on the list",
      "bannerTitle": "You're still on the waitlist",
      "bannerBody": "We'll keep an eye out for another spot."
    },
    "expired": {
      "bannerTitle": "The spot is no longer available",
      "bannerBody": "The spot expired or was canceled. We'll keep looking for another one."
    },
    "dayEnded": {
      "title": "No openings today",
      "body": "No luck today, but your next cut isn't far away. Book the next available date or join tomorrow's waitlist.",
      "bookCta": "Book next available date",
      "joinCta": "Join tomorrow's list"
    },
    "error": "Something went wrong",
    "retry": "Try again",
    "summaryLabel": "Summary",
    "unpaid": "Unpaid",
    "servicesLabel_one": "Service",
    "servicesLabel_other": "Services",
    "stylistLabel": "Stylist",
    "joinedForLabel": "Joined list for",
    "accessibility": {
      "retryButton": "Try again",
      "retryButtonHint": "Reloads your waitlist request",
      "leaveButton": "Leave waitlist",
      "leaveButtonHint": "Opens a confirmation to leave the waitlist",
      "acceptButtonHint": "Opens checkout to pay for this appointment",
      "declineButtonHint": "Opens a confirmation to decline this offer",
      "dismissBanner": "Dismiss",
      "bookButtonHint": "Opens booking to choose your next appointment",
      "joinButtonHint": "Adds you to tomorrow's waitlist",
      "joiningStandby": "Joining tomorrow's list",
      "joinStandbyError": "We couldn't add you to tomorrow's list. Try again."
    },
    "leave": "Leave waitlist",
    "toast": {
      "left": "You left this waitlist. You can join again below.",
      "postLeave": "You've left the waitlist.",
      "expired": "This waitlist has closed for the day.",
      "booked": "You're booked. Check your messages for the appointment details.",
      "unavailable": "This link is no longer valid.",
      "invalidShop": "The shop ID you provided is not valid."
    }
  },
  "StandbyEntryDrawer": {
    "waiting": {
      "title": "You're on the list",
      "subtitle": "When a spot opens, you can accept and pay or decline and keep waiting.",
      "pill": "Waiting"
    },
    "offered": {
      "title": "We found you a spot",
      "subtitle": "Accept and pay or decline to stay on the list and wait for another opening.",
      "accept": "Accept & pay",
      "decline": "Decline & stay on list"
    },
    "details": {
      "date": "Date",
      "duration": "Duration",
      "total": "Total price"
    },
    "timePreference": {
      "morning": "Morning time",
      "afternoon": "Afternoon time",
      "evening": "Evening time",
      "afterHours": "After hours"
    },
    "banner": {
      "expired": {
        "title": "The spot is no longer available",
        "body": "The spot expired or was canceled. We'll keep looking for another one."
      },
      "declined": {
        "title": "You're still on the waitlist",
        "body": "We'll keep an eye out for another spot."
      },
      "dismiss": "Dismiss",
      "dismissHint": "Dismisses this notice"
    },
    "leave": "Leave the waitlist",
    "accessibility": {
      "leaveButton": "Leave the waitlist",
      "leaveButtonHint": "Opens a confirmation to leave the waitlist",
      "acceptButton": "Accept and pay",
      "acceptButtonHint": "Opens checkout to pay for this appointment",
      "declineButton": "Decline and stay on list",
      "declineButtonHint": "Declines this spot and keeps you on the waitlist"
    }
  },
  "StandbyHomeCard": {
    "header": "Waitlist",
    "waiting": "Waiting",
    "joinedOne": "On the list at {{shop}}.",
    "joinedMany": "On the list at {{count}} barbershops.",
    "offerOne": "{{stylist}} has a {{time}} opening at {{shop}}.",
    "offerMany": "You have open spots at {{count}} barbershops.",
    "accessibility": {
      "timeLeft": "{{time}} left",
      "hintEntry": "Opens your waitlist entry",
      "hintList": "Opens your waitlist"
    }
  },
  "StandbyLeaveSheet": {
    "title": "Leave the waitlist?",
    "message": "You'll be removed from the list and won't receive open-spot notifications.",
    "leave": "Leave waitlist",
    "close": "Close",
    "error": "Couldn't leave the list. Try again.",
    "accessibility": {
      "leaveButton": "Leave waitlist",
      "leaveButtonHint": "Removes you from the waitlist",
      "closeButton": "Close",
      "closeButtonHint": "Keeps you on the list and closes this dialog"
    }
  },
  "StandbyDeclineSheet": {
    "title": "Decline this spot?",
    "body": "You'll stay on the waitlist and we'll keep looking for another opening.",
    "confirm": "Decline & stay on list",
    "close": "Keep this spot",
    "error": "Couldn't decline this offer. Try again.",
    "errorToast": "This offer is no longer available.",
    "accessibility": {
      "confirmButton": "Decline & stay on list",
      "confirmButtonHint": "Declines this offer and keeps you on the waitlist",
      "closeButton": "Keep this spot",
      "closeButtonHint": "Closes this dialog and keeps the offer"
    }
  },
  "StandbyCheckoutScreen": {
    "title": "Your order",
    "timeToPay": "Time to pay - ",
    "stylistLabel": "Stylist",
    "anyProfessionalLabel": "Any professional",
    "dateAndTimeLabel": "Date & time",
    "dateAndTimeValue": "{{date}}, at {{time}}",
    "durationMinutes_one": "{{count}} min",
    "durationMinutes_other": "{{count}} min",
    "servicesLabel": "Services",
    "taxesAndFeesLabel": "Taxes & fees",
    "giftCard": "Gift card",
    "tipLabel": "Tip",
    "promoPlaceholder": "Add a gift card or promo code",
    "redeem": "Redeem",
    "continue": "Continue",
    "payInPerson": "Pay in-person",
    "paymentStepPlaceholder": "Payment method",
    "promoInvalidError": "This code isn't valid.",
    "paymentFailedError": "Payment didn't go through. Please try again.",
    "cartMismatchError": "Your order was updated, please review it.",
    "accessibility": {
      "countdown": "Time to pay, {{time}}",
      "stylistRow": "Stylist, {{name}}",
      "dateAndTimeRow": "Date and time, {{date}}, {{duration}}",
      "serviceRow": "{{name}}, {{price}}",
      "promoInput": "Promo or gift card code",
      "promoInputHint": "Enter a promo code or gift card number",
      "redeemButtonHint": "Applies the code to your order",
      "removeCodeButton": "Remove code",
      "removeCodeButtonHint": "Removes the applied code from your order",
      "continueHint": "Moves to the payment step",
      "payInPersonHint": "Books this appointment to pay at the shop",
      "loading": "Loading your order",
      "closeButton": "Close",
      "closeButtonHint": "Closes checkout and returns to your waitlist offer"
    }
  },
  "StandbyPaymentMethod": {
    "title": "Payment method",
    "payTotal": "Pay {{total}}",
    "confirm": "Confirm",
    "walletError": "Payment didn't go through. Please try again.",
    "accessibility": {
      "closeButton": "Close",
      "closeButtonHint": "Returns to your order with the cart intact",
      "payButtonHint": "Completes your payment and books the appointment",
      "backButton": "Back",
      "backButtonHint": "Returns to the payment method list"
    }
  },
  "StandbyOrderConfirmedScreen": {
    "title": "Your order is confirmed!",
    "confirmationCodeLabel": "Confirmation code",
    "addToCalendarLabel": "Add to calendar",
    "rescheduleAppointment": "Reschedule appointment",
    "cancelAppointment": "Cancel appointment",
    "successFallback": {
      "title": "You're booked!",
      "subtitle": "Your booking is confirmed. We're having trouble loading the full confirmation details right now.",
      "toast": "We couldn't load your confirmation details."
    },
    "shopCard": {
      "getDirections": "Get directions",
      "paymentDetailsLabel": "Payment details",
      "chargeTodayDisclaimer": "Your card will be charged today.",
      "paymentPendingBadge": "Payment pending",
      "paidBadge": "Paid",
      "payInPersonValue": "Pay in-person",
      "unpaidBadge": "Unpaid"
    },
    "accessibility": {
      "mapPreview": "Map preview of the shop location",
      "confirmationCode": "Confirmation code {{code}}",
      "addAppleCalendar": "Add to Apple Calendar",
      "addGoogleCalendar": "Add to Google Calendar",
      "rescheduleButtonHint": "Opens the reschedule flow for this appointment",
      "cancelButtonHint": "Opens a confirmation to cancel this appointment",
      "closeButton": "Close",
      "closeButtonHint": "Closes the confirmation"
    }
  },
  "CustomerNotificationView": {
    "unavailable": {
      "title": "This notification is no longer available",
      "subtitle": "The link may have expired. If you still need help, contact your shop or Squire support."
    },
    "supportFooter": "If this message wasn't meant for you, contact us at support@getsquire.com"
  },
  "StandbyWaitlistJoinedScreen": {
    "title": "{{name}}, you're now on the waitlist",
    "leave": "Leave the waitlist",
    "left": "You've left the waitlist.",
    "throttled": "Too many attempts. Wait a moment and try again.",
    "leaveError": "Couldn't leave the list. Try again.",
    "accessibility": {
      "close": "Close",
      "closeHint": "Returns to the shop's booking page",
      "leaveHint": "Removes you from this waitlist right away"
    }
  }
}
